import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { TeachersAvailabilityApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

interface IUseAppointmentHoursGetProps {
  teacherId: number;
  page?: number;
  pageSize?: number;
  lastSelectedId?: number;
  active?: boolean;
}

export const useAppointmentHoursGet = ({
  teacherId,
  page = 1,
  pageSize = 100,
  lastSelectedId,
  active,
}: IUseAppointmentHoursGetProps) => {
  const accessToken = useAccessToken();

  const {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
    isFetching,
    error,
    refetch,
  } = useQuery({
    queryKey: [
      QueryKeys.AppointmentHours,
      teacherId,
      page,
      pageSize,
      lastSelectedId,
      active,
    ],
    queryFn: async () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(
        TeachersAvailabilityApi,
        accessToken,
      );
      return await service.apiAvailabilityTeacherIdAppointmentHoursGet({
        teacherId,
        page,
        pageSize,
        lastSelectedId,
        active,
      });
    },
    enabled: teacherId > 0 && !!accessToken,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
    isFetching,
    error,
    refetch,
  };
};
